module.exports = __webpack_public_path__ + "static/media/camera-stop.85f8745d.svg";